/**
 * Created by Carsten Bühler
 * User: c.buehler on 08.06.2016
 * Copyright: xdot GmbH 2015
 */

import { ClassRemoteDataStore, isAttachedList, isList, RemoteDataStore } from 'plugin/liferay-widgets-react-web';
import ClassNames from '../constants/ClassNames';
import LogicalLayerWebApi from '../webapi/LogicalLayerWebApi';

export default class LogicalLayerStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.LogicalLayer, LogicalLayerWebApi.listGroupLogicalLayers, LogicalLayerWebApi.get);
    }

    static refresh(existing, newRemote) {

        return this.updateQuery(this.invalidateData(existing), {
            start: 0,
            end: existing._end
        });
    }

    websocketModelUpdate(remote, wsUpdate) {
        if (wsUpdate.eventType !== 'POST' && wsUpdate.eventType !== 'PUT' && wsUpdate.eventType !== 'PATCH' && wsUpdate.eventType !== 'PATCH-MERGE' && wsUpdate.eventType !== 'DELETE') {
            if (!Array.isArray(wsUpdate) && !wsUpdate.metric) {
                console.warn('Unknown update type: ', wsUpdate);
            }
        }
        let newRemote;

        RemoteDataStore.remoteStatetoDataArray(remote).filter(d => d.className === wsUpdate.className || d.className === wsUpdate.attachedClassName).forEach(d => {
            if (isList(d)) {
                console.debug('Update', wsUpdate, '==> invalidate list', d);
                d = LogicalLayerStore.refresh(d);
            }
            else if (d.item.id === wsUpdate.classPK) {
                console.debug('Update', wsUpdate, '==> invalidate corresponding item', d);
                if (wsUpdate.op === 'POST') {
                    console.error('Model-Update->', wsUpdate, ' for existing object', wsUpdate, d);
                }
                else if (wsUpdate.op === 'DELETE') {
                    d = RemoteDataStore.updateFlag(d, {
                        _deleted: true,
                        _error: null,
                        _loading: false,
                        _invalid: false
                    });
                } else {
                    d = RemoteDataStore.invalidateData(d);
                }
            }
            else if (d.item.id === wsUpdate.attachedClassPK) {
                console.debug('Update', wsUpdate, '==> invalidate item (attached)', d);
                d = RemoteDataStore.invalidateData(d);
            }

            newRemote = (newRemote || (newRemote = { ...remote }));
            newRemote[ d.name ] = d;
        });

        RemoteDataStore.remoteStatetoDataArray(remote).filter(d => isAttachedList(d, wsUpdate)).forEach(d => {
            console.debug('Update', wsUpdate, '==> invalidate item (attached List)', d);
            d = LogicalLayerStore.refresh(d);

            newRemote = (newRemote || (newRemote = { ...remote }));
            newRemote[ d.name ] = d;
        });

        return newRemote || remote;
    }


}



// WEBPACK FOOTER //
// ./js/stores/LogicalLayerStore.js